import { useNavigate } from "react-router-dom";
import { LogIn, UserPlus, Lock, TrendingUp, Phone, Shield } from "lucide-react";
import { Button } from "./ui/button";
import { Dialog, DialogContent, DialogTitle, DialogDescription } from "./ui/dialog";

const LoginPromptModal = ({ open, onOpenChange, variant = "contact", returnUrl }) => {
  const navigate = useNavigate();

  const goToAuth = (tab = "login") => {
    onOpenChange(false);
    navigate(`/auth?redirect=${encodeURIComponent(returnUrl || window.location.pathname)}&tab=${tab}`);
  };

  const content = {
    contact: {
      icon: <Phone className="w-8 h-8 text-emerald-600" />,
      title: "Vrei să contactezi proprietarul?",
      description: "Creează-ți un cont gratuit pentru a vedea datele de contact ale proprietarului și a programa vizionări.",
      benefits: [
        "Acces la numărul de telefon al proprietarului",
        "Programează vizionări direct din platformă",
        "Salvează anunțurile favorite"
      ]
    },
    credit: {
      icon: <TrendingUp className="w-8 h-8 text-emerald-600" />,
      title: "Vrei să vezi oferta completă de creditare?",
      description: "Creează-ți un cont gratuit pentru a accesa detaliile complete ale ofertelor de credit, inclusiv costuri, scadențar și condiții speciale.",
      benefits: [
        "Detalii complete ale ofertelor de credit",
        "Scadențar personalizat pentru fiecare bancă",
        "Suport gratuit în procesul de creditare"
      ]
    }
  };

  const c = content[variant] || content.contact;

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-md p-0 overflow-hidden" data-testid="login-prompt-modal">
        <DialogTitle className="sr-only">{c.title}</DialogTitle>
        <DialogDescription className="sr-only">{c.description}</DialogDescription>
        {/* Header */}
        <div className="bg-gradient-to-br from-emerald-950 to-emerald-800 p-6 text-white text-center">
          <div className="w-16 h-16 bg-white/20 rounded-2xl flex items-center justify-center mx-auto mb-4">
            {c.icon}
          </div>
          <h3 className="font-['Outfit'] text-xl font-bold mb-2">{c.title}</h3>
          <p className="text-emerald-200 text-sm leading-relaxed">{c.description}</p>
        </div>

        {/* Benefits */}
        <div className="p-6 space-y-3">
          {c.benefits.map((benefit, idx) => (
            <div key={idx} className="flex items-center gap-3">
              <div className="w-6 h-6 bg-emerald-100 rounded-full flex items-center justify-center flex-shrink-0">
                <Shield className="w-3 h-3 text-emerald-600" />
              </div>
              <span className="text-stone-700 text-sm">{benefit}</span>
            </div>
          ))}

          <div className="pt-4 space-y-2">
            <Button
              data-testid="login-prompt-register"
              onClick={() => goToAuth("register")}
              className="w-full h-12 bg-amber-500 hover:bg-amber-600 rounded-xl font-semibold text-base"
            >
              <UserPlus className="w-5 h-5 mr-2" />
              Creează cont gratuit
            </Button>
            <Button
              data-testid="login-prompt-login"
              onClick={() => goToAuth("login")}
              variant="outline"
              className="w-full h-11 rounded-xl text-stone-600"
            >
              <LogIn className="w-4 h-4 mr-2" />
              Am deja un cont
            </Button>
          </div>

          <p className="text-center text-stone-400 text-xs pt-2">
            Contul este gratuit. Datele tale sunt protejate.
          </p>
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default LoginPromptModal;
